// src/App.jsx
import { useEffect, useState } from "react";

export function useNoCaptcha() {
    const [recaptchaReady, setRecaptchaReady] = useState(false);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHA_CLIENT_ID}`;
        script.addEventListener("load", () => setRecaptchaReady(true));
        document.body.appendChild(script);
    }, []);

    const getNoCaptcha = async (action: string) => {
        if (recaptchaReady) {
            try {
                const wd: any = window;
                const token = await wd.grecaptcha.execute(process.env.REACT_APP_CAPTCHA_CLIENT_ID, {
                    action,
                });
                return token;
            } catch (err) {
                return null;
            }
        }
    };

    return {
        ready: recaptchaReady,
        getNoCaptcha,
    }
}
